/* eslint-disable @typescript-eslint/default-param-last */
import { GET_QUOTAS } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IQuotasActionType } from '../types/quotas.types';

const quotasReducer = (
  state = initialState.quotas,
  action: IQuotasActionType
) => {
  switch (action.type) {
    case `${GET_QUOTAS}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default quotasReducer;
